exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accordion[data-v-4a30ddab]{padding:0}.accordion div:last-child .accordion-item-details[data-v-4a30ddab]{border-radius:5px}", ""]);

// exports
